import React from 'react';
import Draggable from 'react-draggable';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
export class RareSkeletonsLibs extends SkeletonRegistryCategory {
    label = 'Libs';
    constructor(parent) {
        super(parent);
        super.init();
    }
    wrapWithDraggable = () => new SkeletonRegistryItem({
        label: 'Wrap with Draggable',
        isAspectWrapper: true,
        jsx: ({ stage, aspect, aspectComponent }) => {
            return (React.createElement(Draggable, { defaultPosition: aspect.aspectDraggable.defaultPosition, offsetParent: stage.inner.aspectMount.domElement, position: aspect.aspectDraggable.definedPosition, onStart: e => {
                    aspect.aspectMount.measureDom.measureManually();
                    aspect.aspectDraggable.isDragging = true;
                    const event = aspect.aspectEvents.eventCreation.createAndFireFromRawEvent({
                        type: 'draggablestart',
                        mouseEvent: e,
                    });
                }, onDrag: e => {
                    aspect.aspectMount.measureDom.measureManually();
                    const event = aspect.aspectEvents.eventCreation.createAndFireFromRawEvent({
                        type: 'draggabledrag',
                        mouseEvent: e,
                    });
                    aspect.aspectDraggable.latestDragEvent = event;
                }, onStop: e => {
                    aspect.aspectMount.measureDom.measureManually();
                    aspect.aspectDraggable.isDragging = false;
                    const event = aspect.aspectEvents.eventCreation.createAndFireFromRawEvent({
                        type: 'draggableend',
                        mouseEvent: e,
                    });
                    aspect.aspectDraggable.latestDragEvent = undefined;
                } },
                React.createElement("div", { style: { cursor: 'move', ...aspect.actor.ownAspect.draggable.aspectCss.css } }, aspectComponent)));
        },
    });
}
